import React, { useEffect, useState } from "react";
import "../../App.css";
import PageTitle from "../../Module/pageTitle";
import { useDispatch, useSelector } from "react-redux";
import { setParentCourse } from "../../Action/courseAction";
import AdminTable from "../../Component/adminTable";
import { showErrorSnackbar } from "../../Action/snackbarAction";
import {
  containsNumber,
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace,
  image_size_150,
  image_size_5MB,
  length_Hundred,
  length_Ten,
  length_Three,
  validateIsFileImageType,
  validateNameWithoutSpace,
} from "../../Utils/validators";
import {
  containsNumberErrMsg,
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg,
  validateFullNameErrMsg,
  validateIsFileImageTypeErrMsg,
} from "../../Utils/errorMsg";
import ImagePickerAndViewer from "../../Component/imagePickerAndViewer";
import SubmitButton from "../../Component/SubmitButton";
import {
  deleteExamStream,
  getExamStream,
  updateExamStream,
  uploadExamStreamLogo,
} from "../../Action/adminPanelAction";
import LabelField from "../../Component/labelField";
import FormInputField from "../../Component/FormInputField";

function EditParentCourse() {
  const initialVal = {
    name: "",
    seoName: "",
    expertDetails: {
      mobileNo: "",
      message: "",
    },
    file: "",
  };

  const { isEditMode } = useSelector((state) => ({
    isEditMode: state.courseReducer?.isEditMode,
  }));

  const dispatch = useDispatch();
  const [examStreamId, setExamStreamId] = useState("");
  const [examStreamLogo, setExamStreamLogo] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  const [examStreamList, setExamStreamList] = useState([]);
  const [examStreamArr, setExamStreamArr] = useState(initialVal);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    dispatch(
      getExamStream((res) => {
        setExamStreamList(res);
      })
    );
  };

  const onChange = (value, key) => {
    let newArray = JSON.parse(JSON.stringify(examStreamArr));
    if (key === "name") {
      if (value.length === length_Hundred) {
        dispatch(
          showErrorSnackbar(
            `Max Length ${length_Hundred - 1} reached for this field`
          )
        );
      } else if (containsNumber(value)) {
        dispatch(showErrorSnackbar(containsNumberErrMsg));
        return;
      } else {
        newArray[key] = value;
        setExamStreamArr(newArray);
      }
    } else if (key === "seoName") {
      if (value.length === length_Hundred) {
        dispatch(
          showErrorSnackbar(
            `Max Length ${length_Hundred - 1} reached for this field`
          )
        );
      } else if (containsNumber(value)) {
        dispatch(showErrorSnackbar(containsNumberErrMsg));
        return;
      } else if (!validateNameWithoutSpace(value)) {
        dispatch(showErrorSnackbar(validateFullNameErrMsg));
        return;
      } else {
        newArray[key] = value;
        setExamStreamArr(newArray);
      }
    } else if (key === "mobileNo") {
      if (value !== "") {
        if (!containsNumber(value)) {
          dispatch(showErrorSnackbar("Only Numbers are allowed!"));
          return;
        } else {
          newArray["expertDetails"][key] = value;
          setExamStreamArr(newArray);
        }
      } else {
        newArray["expertDetails"][key] = value;
        setExamStreamArr(newArray);
      }
    } else if (key === "message") {
      if (value.length === length_Hundred) {
        dispatch(
          showErrorSnackbar(
            `Max Length ${length_Hundred - 1} reached for this field`
          )
        );
      } else if (
        containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace(value)
      ) {
        dispatch(
          showErrorSnackbar(
            containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg
          )
        );
        return;
      } else {
        newArray["expertDetails"][key] = value;
        setExamStreamArr(newArray);
      }
    }
  };

  const onChangeLogo = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_5MB) {
      dispatch(showErrorSnackbar("File size should be less than 5 MB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setExamStreamLogo(reader.result);
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEdit = (value) => {
    dispatch(setParentCourse("isEditMode", true));
    const data = {
      name: value?.name,
      expertDetails: {
        mobileNo: value?.expertDetails?.mobileNo,
        message: value?.expertDetails?.message,
      },
      file: value?.file,
      seoName: value?.seoName,
    };
    setExamStreamId(value._id);
    setExamStreamArr(data);
  };

  const handleUpdate = (e) => {
    e.preventDefault();

    if (selectedImage) {
      dispatch(
        uploadExamStreamLogo(selectedImage, (res) => {
          if (res) {
            examStreamArr["file"] = res?.file;
            const postData = examStreamArr;
            dispatch(
              updateExamStream(postData, examStreamId, () => {
                setExamStreamArr(initialVal);
                setSelectedImage("");
                setExamStreamLogo("");
                dispatch(setParentCourse("isEditMode", false));
                fetchData();
              })
            );
          }
        })
      );
    } else {
      delete examStreamArr?.file;
      const postData = examStreamArr;
      dispatch(
        updateExamStream(postData, examStreamId, () => {
          setExamStreamArr(initialVal);
          setSelectedImage("");
          setExamStreamLogo("");
          dispatch(setParentCourse("isEditMode", false));
          fetchData();
        })
      );
    }
  };

  const handleDelete = (value) => {
    dispatch(
      deleteExamStream(value._id, () => {
        fetchData();
      })
    );
  };

  const validations = () => {
    return (
      examStreamArr?.name === "" ||
      examStreamArr?.name.length < 3 ||
      examStreamArr?.expertDetails?.mobileNo === "" ||
      examStreamArr?.expertDetails?.mobileNo.length !== 10 ||
      examStreamArr?.expertDetails?.message === "" ||
      examStreamArr?.expertDetails?.message.length < 10
    );
  };

  const renderEditMode = () => {
    return (
      <div className="col-6">
        <div className="mb-2">
          <div className="d-flex align-items-center">
            <LabelField labelName={"Exam Stream"} isRequired={true} />
            <FormInputField
              key={"ex"}
              placeholder={"Enter Exam Stream Name"}
              setInputText={(value) => onChange(value, "name")}
              value={examStreamArr?.name}
              maxLength={length_Hundred}
              minLength={length_Three}
            />
          </div>
          <div className="d-flex align-items-center">
            <LabelField labelName={"Expert Number"} isRequired={true} />
            <FormInputField
              key={"e"}
              placeholder={"Enter Expert Number"}
              setInputText={(value) => onChange(value, "mobileNo")}
              value={examStreamArr?.expertDetails?.mobileNo}
              maxLength={length_Ten}
              minLength={length_Ten}
            />
          </div>
          <div className="d-flex align-items-center">
            <LabelField
              labelName={"Talk To Expert message"}
              isRequired={true}
            />
            <FormInputField
              key={"m"}
              placeholder={"Enter Talk To Expert message"}
              setInputText={(value) => onChange(value, "message")}
              value={examStreamArr?.expertDetails?.message}
              maxLength={length_Hundred}
              minLength={length_Ten}
            />
          </div>
          <div className="d-flex align-items-center">
            <LabelField labelName={"Exam Stream SEO Name"} isRequired={true} />
            <FormInputField
              key={"seo"}
              placeholder={"Enter Exam Stream SEO Name"}
              setInputText={(value) => onChange(value, "seoName")}
              value={examStreamArr?.seoName}
              maxLength={length_Hundred}
              minLength={length_Three}
            />
          </div>
          <ImagePickerAndViewer
            labelName={"Exam Logo"}
            value={
              examStreamArr?.file?.length > 0
                ? examStreamArr?.file
                : examStreamLogo
            }
            handleChange={(e) => onChangeLogo(e)}
            htmlFor={"photo-upload"}
            isRequired={true}
          />
        </div>
        <SubmitButton name="Save and Update" validations={validations()} />
      </div>
    );
  };

  const renderListMode = () => {
    return (
      <AdminTable
        tableData={examStreamList ? examStreamList : []}
        pagename={"ParentCourse"}
        tableHead={[
          "S.N",
          "Exam Stream Name",
          "Expert Number",
          "Message",
          // "CRM Exam Stream",
          "Logo",
          "SEO Subject Name",
          "Actions",
        ]}
        handleEdit={(value) => handleEdit(value)}
        handleDelete={(value) => handleDelete(value)}
        edit={true}
      />
    );
  };

  const handleCancelEditMode = () => {
    dispatch(setParentCourse("isEditMode", false));
  };

  return (
    <div className="contentBox">
      <PageTitle
        name={"EDIT Exam Stream"}
        isEditMode={isEditMode}
        onClick={handleCancelEditMode}
      />
      <div className="formDiv contentScrollbar">
        <form className="col-auto formWidth" onSubmit={handleUpdate}>
          {!isEditMode ? renderListMode() : renderEditMode()}
        </form>
      </div>
    </div>
  );
}

export default EditParentCourse;
